// @ts-check
import { useEffect, useState } from "react";

/**
 * Adia a atualização de um valor até ele parar de mudar.
 *
 * Usado na busca: sem isto, cada tecla dispararia uma requisição.
 *
 * @template T
 * @param {T} valor
 * @param {number} [atraso] milissegundos
 * @returns {T}
 */
export function useDebounced(valor, atraso = 300) {
  const [adiado, setAdiado] = useState(valor);

  useEffect(() => {
    const timer = setTimeout(() => setAdiado(valor), atraso);
    return () => clearTimeout(timer);
  }, [valor, atraso]);

  return adiado;
}
